<div class="mb-4 border p-3 rounded bg-secondary" style="--bs-bg-opacity: .2;">
  <h3>{{record ? 'Evento N°' + record.id : 'Nuovo Evento'}}</h3>
  <hr>
  <div *ngIf="!isNew && !isAbsence && !isAplContract" class="input-field my-2">
    <label class="label me-3" for="paymentLink">Clicca qui per generare il link di pagamento:</label>
    <button id="paymentLink" (click)="createPaymentLink()" class="btn btn-primary text-white">Genera</button>
  </div>
  <div *ngIf="!isNew && isAplContract" class="input-field my-2 text-muted">
    <i class="bi bi-info-circle me-2"></i>Utilizzo in Contratto APL: la partita si chiude tramite fattura Synergie, nessun link di pagamento F+H.
  </div>
  <p class="fw-light fs-6">(*) Campi obbligatori</p>
  <form [formGroup]="newRecordForm">
    <div class="row g-3">
      <div class="col-md-4">
        <label class="form-label fw-bold">Evento*</label>
        <select class="form-select" formControlName="eventType">
          <option value='REPLACEMENT'>Sostituzione</option>
          <option value='USAGE'>Utilizzo</option>
          <option value='ABSENCE'>Assenza Ingiustificata</option>
          <option value='TRIAL'>Periodo di prova</option>
          <option value='ACTIVATION'>Attivazione</option>
        </select>
      </div>
      <div class="col-md-4">
        <label class="form-label fw-bold">Data di Inizio*</label>
        <input type="date" class="form-control" formControlName="startDate" />
      </div>

      <div class="col-md-4">
        <label class="form-label fw-bold">Data di Fine*</label>
        <input type="date" class="form-control" formControlName="endDate" />
      </div>

      <div class="col-md-4">
        <label class="form-label fw-bold">Status*</label>
        <select type="text" class="form-select" formControlName="paymentStatus" [attr.disabled]="isAbsence ? true : null">
          <option value='TO_PAY'>Da pagare</option>
          <option value='PENDING'>Da validare</option>
          <option value='PAID'>Pagato</option>
          <option value='CANCELLED'>Annullato</option>
          <option value='REFUNDED'>Rimborsato</option>
          <option value='CONTRATTO_APL'>Contratto APL</option>
        </select>
      </div>

<div class="col-md-4">
  <label class="form-label fw-bold">Caregiver assegnato<span *ngIf="isAbsence">*</span></label>
  <select class="form-select" [class.is-invalid]="isAbsence && !caregiverId.value"
    [ngModel]="selectedCaregiver" (ngModelChange)="onCaregiverSelect($event)" [ngModelOptions]="{ standalone: true }">
    <option [ngValue]="null">NESSUN CAREGIVER ASSEGNATO</option>
    <option *ngFor="let caregiver of caregiverList" [ngValue]="caregiver">
      {{ caregiver.caregiverName }}
    </option>
  </select>
  <div class="text-danger mt-1 small" *ngIf="isAbsence && !caregiverId.value">
    Il campo è obbligatorio.
  </div>
</div>

      <div class="col-md-4">
        <label class="form-label fw-bold">Ore Effettuate*</label>
        <input type="number" [min]="0" class="form-control" formControlName="hoursWorked" />
        <div class="text-danger mt-1 small"
          *ngIf="hoursWorked?.invalid && (hoursWorked?.dirty || hoursWorked?.touched)">

          <!-- Se supera il massimo -->
          <div *ngIf="hoursWorked?.errors?.['max']">
            Il numero di ore disponibili non può superare {{ hoursValidator }} ore.
          </div>

          <!-- Se è vuoto, opzionale -->
          <div *ngIf="hoursWorked?.errors?.['required']">
            Il campo è obbligatorio.
          </div>
        </div>
      </div>

      <div class="col-md-4">
        <label class="form-label fw-bold">Importo Seduta*</label>
        <input type="number" [min]="0" class="form-control" formControlName="sessionAmount" [readonly]="isAbsence" />
        <div class="text-danger mt-1 small"
          *ngIf="sessionAmount?.invalid && (sessionAmount?.dirty || sessionAmount?.touched)">
          <div *ngIf="sessionAmount?.errors?.['required']">
            Il campo è obbligatorio.
          </div>
          <div *ngIf="sessionAmount?.errors?.['min']">
            L'importo non può essere negativo.
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-center" *ngIf="!isAbsence">
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="discounted" formControlName="discounted" />
          <label class="form-check-label fw-bold" for="discounted">Scontato</label>
        </div>
      </div>


      <div *ngIf="!isNew && !isAbsence && !isAplContract" class="w-100 d-flex align-items-center gap-2">
        <div class="w-75">
          <label class="form-label fw-bold">Link di pagamento</label>
          <div class="d-flex gap-2">
            <input type="text" class="form-control" formControlName="paymentLink" />
            <div *ngIf="record" class="d-flex align-items-center">
              <button (click)="savePaymentLink()"
                [disabled]="PaymentStatus.value !=='TO_PAY' || PaymentLink.value ==='' || PaymentLink.value === null"
                class="btn btn-secondary text-white">Salva</button>
            </div>
          </div>
          <p class="fw-light">*Generare il link di pagamento dalla sezione "Messaggi richiesta", quindi inserirlo nel
            qui
            se necessario.</p>
        </div>
      </div>

      <div class="w-full d-flex align-items-center gap-2">
        <div class="w-100">
          <label class="form-label fw-bold">Note</label>
          <textarea type="" maxlength="250" class="form-control" formControlName="notes"></textarea>
        </div>
      </div>

      <div *ngIf="!record" class="mt-3 d-flex justify-content-end">
        <button class="btn btn-primary text-white" [disabled]="this.newRecordForm.invalid"
          (click)="saveRound()">Salva</button>
      </div>
      <div *ngIf="record" class="mt-3 d-flex gap-2 justify-content-end">
        <button class="btn btn-secondary text-white" [disabled]="this.newRecordForm.invalid"
          (click)="updateRound()">Aggiorna</button>
      </div>
    </div>
  </form>
